// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TQfO","footer":"styles_footer__2KdDz","passCodeTooltip":"styles_passCodeTooltip__29qrt"};